import { useSiteContent } from '@/context/SiteContent';
import { Wordmark } from '@/components/yunti/Wordmark';

export function Footer() {
  const { brand, footer } = useSiteContent();
  return (
    <footer className="bg-yunti-ink text-yunti-ground py-16 px-6 lg:px-12 border-t border-yunti-ink" data-testid="footer">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-end gap-10">
        <div>
          <div className="text-3xl font-display uppercase tracking-tight text-white mb-2">
            <Wordmark text={brand.name} />
          </div>
          {brand.tagline && (
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-yunti-purplelight">{brand.tagline}</p>
          )}
        </div>

        <div className="flex flex-wrap gap-8 text-xs font-mono uppercase tracking-widest text-yunti-ground/70">
          <a href="#products" className="hover:text-white transition-colors" data-testid="footer-shop-link">
            {footer.shop}
          </a>
          <a href="#contact" className="hover:text-white transition-colors" data-testid="footer-contact-link">
            {footer.contact}
          </a>
          {footer.instagramUrl ? (
            <a
              href={footer.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
              data-testid="footer-instagram-link"
            >
              {footer.instagram}
            </a>
          ) : (
            <span
              className="text-yunti-ground/40 cursor-default"
              title="Official Instagram handle coming soon"
              data-testid="footer-instagram-placeholder"
            >
              {footer.instagram}
            </span>
          )}
        </div>

        <div className="text-xs font-mono text-yunti-ground/50 md:text-right space-y-1">
          <div>{footer.copyright}</div>
          <div className="text-yunti-purplelight">{footer.collection}</div>
        </div>
      </div>
    </footer>
  );
}
